import { Examples } from '@/types';

export const ExampleBuiltInListDynamicFormModal =
  process.env.NODE_ENV !== 'production'
    ? [
      {
        ...Examples.ExampleBuiltInListDynamicFormModal,
        components: {
          default: () => import( 
          '@/views/examples/ExampleBuiltInListDynamicFormModal.vue')
        }
      }
    ]
    : [];
